import PlayStore from './playStore';

export const playStore = new PlayStore();
